import { Box, Button, Typography } from '@mui/material';
import { useMemo } from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import AppShell, { SettingsGroup } from '../components/layout/AppShell';
import DesignSystem from '../designSystem';
import { publicProfileUrl } from '../utils/publicProfileUrl';
import { useT } from '../i18n/useT';

export default function QrCodePage() {
  const t = useT();
  const { username } = useParams<{ username: string }>();
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const name = params.get('name') || username || t('visiShellTitle');

  const profileUrl = useMemo(() => publicProfileUrl(username), [username]);

  const qrSrc = useMemo(() => {
    return `https://api.qrserver.com/v1/create-qr-code/?size=280x280&data=${encodeURIComponent(profileUrl)}`;
  }, [profileUrl]);

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(profileUrl);
    } catch {
      // ignore
    }
  };

  return (
    <AppShell title={t('qrCode')} showBackButton maxWidth="sm" showCompanion={false}>
      <SettingsGroup>
        <Box sx={{ p: 3, textAlign: 'center' }}>
          <Typography sx={{ fontSize: 20, fontWeight: 700, mb: 0.5 }}>{name}</Typography>
          <Typography sx={{ fontSize: 14, color: DesignSystem.colors.textSecondary, mb: 3 }}>
            {t('qrScanHint')}
          </Typography>
          <Box
            sx={{
              display: 'inline-block',
              p: 2,
              bgcolor: '#fff',
              borderRadius: DesignSystem.borderRadius.lg,
              border: `1px solid ${DesignSystem.colors.separator}`,
              mb: 2.5,
            }}
          >
            <Box component="img" src={qrSrc} alt={t('qrCodeAria')} width={240} height={240} />
          </Box>
          <Typography sx={{ fontSize: 13, mb: 2.5, wordBreak: 'break-all', color: DesignSystem.colors.textSecondary }}>
            {profileUrl}
          </Typography>
          <Box sx={{ display: 'flex', gap: 1, justifyContent: 'center', flexWrap: 'wrap' }}>
            <Button variant="contained" onClick={() => void copy()} sx={{ textTransform: 'none', borderRadius: 999, boxShadow: 'none' }}>
              {t('qrCopyLink')}
            </Button>
            <Button
              variant="outlined"
              onClick={() => navigate(`/${(username || '').replace(/^@/, '')}`)}
              sx={{ textTransform: 'none', borderRadius: 999 }}
            >
              {t('qrOpenProfile')}
            </Button>
          </Box>
        </Box>
      </SettingsGroup>
    </AppShell>
  );
}
